import { render, staticRenderFns } from "./TableColumnOperations.vue?vue&type=template&id=63377430"
import script from "./TableColumnOperations.vue?vue&type=script&lang=js"
export * from "./TableColumnOperations.vue?vue&type=script&lang=js"
import style0 from "./TableColumnOperations.vue?vue&type=style&index=0&id=63377430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports